import {RuleType} from '../../enums';
import {texts} from '../../texts';

export const getOverviewDialogTitle = (type: RuleType): string => {
    if (type === RuleType.business) {
        return texts.business_rules_option_title;
    } else if (type === RuleType.autofill) {
        return texts.autofill_rules_option_title;
    }
    return '';
};

export const getOpenRuleDialogTitle = (type: RuleType): string => {
    if (type === RuleType.business) {
        return texts.business_rules_dialog_title;
    } else if (type === RuleType.autofill) {
        return texts.new_autofill_rule_dialog_title;
    }
    return '';
};
